import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { oneLine } from 'common-tags';
import { leaderboards } from './leaderboard';
export var channels = [{
  __typename: 'Channel',
  id: '1',
  name: 'My Cool Channel',
  darkMode: true,
  usePrimaryColorForOverlay: false,
  availableChallengeCount: 5,
  banner: {
    id: 'ac858154-3164-46a9-a699-707b28e01000',
    blurhash: 'LCDvTR%MD%4:?wo#RORO_NIoxBRO'
  },
  description: oneLine(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      My description is very interesting and also long, wow this just goes on forever and ever.\n      This is the best channel ever because of how long the description is.\n    "]))),
  leaderboard: leaderboards[0],
  newChallengeCount: 3
}, {
  __typename: 'Channel',
  id: '2',
  name: 'My Cool Channel 2',
  darkMode: false,
  usePrimaryColorForOverlay: true,
  availableChallengeCount: 1,
  banner: null,
  description: oneLine(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      My description is very interesting and also long, wow this just goes on forever and ever.\n      This is the best channel ever because of how long the description is.\n    "]))),
  leaderboard: leaderboards[0],
  newChallengeCount: 0
}];